import style from './style.scss'
import React, {FunctionComponent} from 'react'
import {useTranslation} from 'react-i18next'
import {IProps} from './IProps'
import {Currency, Percent} from '../../../../../../App/Components/Format'

const OverviewPerson: FunctionComponent<IProps> = ({personTotal, target, person}) => {
    const {t} = useTranslation()

    const personPercentage = personTotal / target.amount

    return (
        <li className={style.overviewPerson}>
            <p className={style.leftColumn}>{person.name}</p>
            <div className={style.middleColumn}>
                <progress className={style.progress} value={`${personTotal}`} max={`${target.amount}`}>
                    <Percent>{personPercentage}</Percent>
                </progress>
            </div>
            <p className={style.rightColumn1}><Currency>{personTotal}</Currency></p>
            <p className={style.rightColumn1Mobile}><Currency>{personTotal}</Currency></p>
            <p className={style.rightColumn2}><Percent>{personPercentage}</Percent></p>
            <p className={style.rightColumn2Mobile}><Percent>{personPercentage}</Percent></p>
        </li>
    )
}

export default OverviewPerson
